module.exports = __webpack_public_path__ + "img/l6.3696c924.png";